import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ReferenceDataCategoriesConstants,
  ReferenceDataConstants,
  ReferenceDataService,
  RomeNotificationService
} from 'rome-library';

@Injectable()
export class ErrorLoggerService {
  private readonly errorsOutputChannel;

  constructor(
    private readonly notificationService: RomeNotificationService,
    private readonly referenceDataService: ReferenceDataService
  ) {
    this.errorsOutputChannel = this.referenceDataService.getConfigurationValue(
      ReferenceDataCategoriesConstants.CLIENT_ENVIRONMENT_CATEGORY,
      ReferenceDataConstants.UIErrorsOutput
    );
  }

  public log(error: Error | HttpErrorResponse): void {
    switch (this.errorsOutputChannel) {
      case ReferenceDataConstants.UIErrorsOutputNotification:
        const errorMessage = error instanceof HttpErrorResponse ? error.error?.Message : error.message;
        this.notificationService.showError(errorMessage);
      // eslint-disable-next-line no-fallthrough
      case ReferenceDataConstants.UIErrorsOutputConsole:
        if (error instanceof Error) {
          // the stack trace must be converted to string to keep the error column number
          console.error({ ...error, stack: error.stack.toString() });
        } else {
          console.error(error);
        }
        break;
      default:
        break;
    }
  }
}
